import { useState, useEffect } from 'react';
import axios from 'axios';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function MediaLibrary({ onRefresh }) {
  const [projects, setProjects] = useState([]);
  const [allImages, setAllImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMedia();
  }, []);

  const fetchMedia = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/projects`);
      setProjects(res.data);
      
      // Flatten all images
      const images = [];
      res.data.forEach(project => {
        if (project.images) {
          project.images.forEach(img => {
            images.push({
              ...img,
              projectTitle: project.title,
              projectId: project.id
            });
          });
        }
      });
      setAllImages(images);
    } catch (error) {
      toast.error('Failed to fetch media');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="media-library">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Media Library</h2>
        <p className="text-sm text-gray-500">{allImages.length} total images</p>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {[...Array(12)].map((_, i) => (
            <div key={i} className="skeleton aspect-square" />
          ))}
        </div>
      ) : allImages.length === 0 ? (
        <Card className="p-12 text-center">
          <p className="text-gray-400">No images in library. Upload images to your projects!</p>
        </Card>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {allImages.map((img) => (
            <Card key={img.id} className="overflow-hidden group cursor-pointer hover:shadow-lg transition-shadow" data-testid={`media-item-${img.id}`}>
              <div className="aspect-square relative">
                <img
                  src={img.thumb_url}
                  alt={img.filename}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2">
                  <p className="text-white text-xs font-semibold text-center mb-1">{img.projectTitle}</p>
                  <p className="text-white text-[10px] text-center opacity-75">{img.filename}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}